import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';
import { ClientsService, SelectedClient } from 'src/app/services/clients/clients.service';
import { PayeeCasesService } from 'src/app/shared/payee-cases/payee-cases.service';

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss']
})
export class CasesComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly getCasesPath: string = `api/case`;
  readonly getDebtorsPath: string = `api/debtor`;

  private readonly destroy = new Subject<void>();

  constructor(
    private payeeCasesService: PayeeCasesService,
    private clientsService: ClientsService,
    private titleService: Title,
    private translate: TranslateService,
  ) {
  }

  ngOnInit(): void {
    this.translate.stream('BROWSER_TITLES.CASES')
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: v => this.titleService.setTitle(v),
      });
  }

  ngAfterViewInit(): void {
    this.clientsService.selectedClientSubject
      .pipe(
        takeUntil(this.destroy),
        startWith(this.clientsService.selectedClientSubject.value),
      )
      .subscribe(c => this.filterClient(c));
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  private filterClient(c?: SelectedClient): void {
    this.payeeCasesService.client.next(c
      ? {
        id: c.id,
        name: c.name,
      }
      : null,
    );
  }
}
